import { useCallback } from 'react';

export interface Coords {
  lat: number;
  lng: number;
}

function useCoordsAddress() {
  const findCoordinates = useCallback(async (address: string): Promise<Coords | null> => {
    const OpenStreetMapProvider = require('leaflet-geosearch').OpenStreetMapProvider;
    const provider = new OpenStreetMapProvider();
    try {
      const results = await provider.search({ query: address });
      if (results.length === 0) return null;
      return { lng: results[0].x, lat: results[0].y };
    } catch (error) {
      console.error('Error fetching geolocation data:', error);
      return null;
    }
  }, []);

  return { findCoordinates };
}

export default useCoordsAddress;
